export enum ProductTypeEnum {
	ASSIGNMENT = 'Abtretung',
	REPORT = 'Prüfbericht',
	OTHER = 'Sonstige',
}
